import { cloneDeep } from 'lodash';
import { DESIGNER_PANEL_ID, JSON_PANEL_ID } from './controlDesignerDockPanelRegistry.js';

function isCenterTabGroupViews(views) {
    return Array.isArray(views)
        && views.includes(DESIGNER_PANEL_ID)
        && views.includes(JSON_PANEL_ID);
}

/** Never restore with JSON as the selected center tab. */
function normalizeCenterGroupActiveView(groupData) {
    if (!groupData || !isCenterTabGroupViews(groupData.views))
        return groupData;

    if (groupData.activeView === JSON_PANEL_ID)
        groupData.activeView = DESIGNER_PANEL_ID;

    return groupData;
}

function walkGridNode(node) {
    if (!node)
        return node;

    if (node.type === 'leaf' && node.data) {
        normalizeCenterGroupActiveView(node.data);
        return node;
    }

    if (node.type === 'branch' && Array.isArray(node.data)) {
        for (const child of node.data)
            walkGridNode(child);
    }

    return node;
}

/**
 * Adjust persisted dock layout so the JSON tab is never the restored center tab.
 * @param {object | null | undefined} layoutJson
 */
export function migrateControlDesignerDockLayout(layoutJson) {
    if (!layoutJson?.grid?.root)
        return layoutJson;

    const next = cloneDeep(layoutJson);
    walkGridNode(next.grid.root);

    if (next.edgeGroups) {
        for (const entry of Object.values(next.edgeGroups)) {
            if (entry?.group)
                normalizeCenterGroupActiveView(entry.group);
        }
    }

    if (Array.isArray(next.floatingGroups)) {
        for (const entry of next.floatingGroups) {
            if (entry?.data)
                normalizeCenterGroupActiveView(entry.data);
        }
    }

    return next;
}

/**
 * @param {import('dockview-core').DockviewApi | null | undefined} api
 */
export function activateDesignerCenterTab(api) {
    const panel = api?.getPanel?.(DESIGNER_PANEL_ID);
    panel?.api?.setActive?.();
}
